var _style, _g, _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOnePointFiveTon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 200",
    style: {
      enableBackground: "new 0 0 500 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#9AE5FC;}\r\n\t.st1{fill:none;stroke:#4E4868;stroke-width:12;stroke-miterlimit:10;}\r\n\t.st2{fill:#4E4868;}\r\n\t.st3{fill:none;stroke:#0F0F0F;stroke-width:6;stroke-miterlimit:10;}\r\n\t.st4{fill:#4E4868;stroke:#4E4868;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st5{fill:#DBDAE1;}\r\n\t.st6{fill:#EAE9ED;}\r\n\t.st7{fill:#EFDD03;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M364.4,25.1v22.8c0,2.9,2,5.4,4.8,6.1L416,65.7c0.1,0,0.3,0.1,0.4,0.1c4,1.3,5,1.3,6.3-0.1 c3.8-4-2.2-19.2-10.8-29.1c-0.2-0.3-0.5-0.5-0.7-0.7c-2-1.7-12.1-9.8-27-15.4c-3.5-1.3-7-2.7-8.5-3.2c-0.5-0.2-1-0.3-1.4-0.4 l-2.4-0.5c-3.9-0.7-7.5,2.3-7.5,6.2V25.1L364.4,25.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 362.7,
    cy: 149.9,
    r: 27.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 138.3,
    cy: 149.9,
    r: 27.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M181.1,149.9H317c1.8,0,3.3-1.4,3.3-3.3V141c0-1.8-1.5-3.3-3.3-3.3H181.5c-1.8,0-3.3,1.4-3.3,3.3v5.9 C178.2,148.6,179.6,149.9,181.1,149.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M56.7,149.9h36.1c1.9,0,3.4-1.3,3.4-3v-6.1c0-1.7-1.5-3-3.4-3H56.7c-1.9,0-3.4,1.3-3.4,3v6.1 C53.3,148.6,54.8,149.9,56.7,149.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M403,129.9c13.1,0,26.3,0,39.5,0c2.8,0,5.3-2.1,5.5-4.9c1.2-10.4,1.7-23.4-0.7-38c-5.4-33.7-22-57.5-32.7-70 c-2-2.4-5.1-3.8-8.2-3.8h-67.2c-2.2,0-3.9,1.8-3.9,3.9v94.7c0,1.6,1.7,2.6,3.1,1.8c6.1-3.3,19.8-9.1,36.2-4.8 C392.2,113.5,401.1,126.8,403,129.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M425.4,94.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M358.5,18.3v41.5c0,4.1,2.9,7.7,6.9,8.6l53.7,11.7c2.8,0.6,4.8,2.9,5.3,5.7l1.1,8.6"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M122.7,149.9c-0.1-8.6,6.9-15.5,15.6-15.5c8.5,0,15.5,6.9,15.6,15.1c0.2,8.9-6.6,15.9-15.5,16 C129.6,165.7,122.7,158.9,122.7,149.9z M138.2,155.2c2.8,0,5.2-2.3,5.3-5.2s-2.1-5.2-5.1-5.3c-3.1-0.1-5.5,2.3-5.4,5.3 C132.9,152.8,135.4,155.2,138.2,155.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M347.3,149.4c-0.1-8.6,6.9-15.5,15.6-15.5c8.5,0,15.5,6.9,15.6,15.1c0.2,8.9-6.6,15.9-15.5,16 C354.1,165.2,347.3,158.4,347.3,149.4z M362.8,154.7c2.8,0,5.2-2.3,5.3-5.2c0.1-2.9-2.1-5.2-5.1-5.3s-5.5,2.3-5.4,5.3 C357.5,152.3,360,154.7,362.8,154.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M64.8,67.8c12,0,24,0,36,0c4.5,0,7.5,2.9,7.4,6.8c-0.1,3.7-3,6.2-7.4,6.3c-0.7,0-1.4,0-2.2,0 c-11.3,0-22.5,0-33.8,0C64.4,76.6,64.4,72.2,64.8,67.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M40.7,60.9c-4,0-7-2.8-6.8-7.2c0.1-3.1-0.7-4.4-4.1-4.3c-4.6,0.1-7.3-2.7-7.3-6.8c0-3.6,2.9-6.3,7.3-6.1 c3.3,0.1,4.1-1,4.1-4.3c-0.1-4.3,3.1-7.9,6.4-7.9c4,0,7.4,3.6,7.4,8c0,2.7,0.1,4,3.7,3.6c4.8-0.4,7.6,2.4,7.7,6.3 c0.1,4.3-2.5,7-7.5,7.1c-3.2,0.1-3.8,1.6-3.8,4.4C47.6,58.2,44.8,60.9,40.7,60.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M289,25c0,10.6-7.3,17.1-18.2,17.7c-10.5,0.5-17.9-9.5-17.8-18.3c0.1-8.1,7.4-18.5,18.9-17.8 C282,7.3,289,14.3,289,25z M276,24.6c-0.8-2.5-1.8-5-5.1-4.8c-3,0.2-4.3,2.6-4.4,5.1c-0.1,3,2.5,4.4,5,4.1 C273.8,29,275.9,27.6,276,24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M459.1,43.5c-4,0-7-2.8-6.9-7.2c0.1-3.1-0.7-4.4-4.1-4.3c-4.6,0.1-7.3-2.7-7.3-6.8c0-3.6,2.9-6.3,7.3-6.1 c3.3,0.1,4.1-1,4.1-4.3c-0.1-4.3,3.1-7.9,6.4-7.9c4,0,7.4,3.6,7.4,8c0,2.7,0.1,4.1,3.7,3.6c4.8-0.4,7.6,2.4,7.7,6.3 c0.1,4.3-2.5,7-7.5,7.1c-3.2,0.1-3.8,1.6-3.8,4.4C466.1,40.8,463.3,43.5,459.1,43.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M197.8,193.4h-111c-2.6,0-4.8-2.6-4.8-5.8l0,0c0-3.2,2.1-5.8,4.8-5.8h111c2.6,0,4.8,2.6,4.8,5.8l0,0 C202.6,190.9,200.4,193.4,197.8,193.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M441.9,123.6V100c-4.3,0.3-7.6,1.4-9.7,2.2c-2.6,1.1-9,4.6-13.6,13.5c-1.7,3.2-2.3,6.1-2.6,7.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M428.4,193.4H294.8c-3.2,0-5.8-2.6-5.8-5.8l0,0c0-3.2,2.6-5.8,5.8-5.8h133.6c3.2,0,5.8,2.6,5.8,5.8l0,0 C434.1,190.9,431.6,193.4,428.4,193.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M71.9,193.4H59.1c-3.2,0-5.8-2.6-5.8-5.8l0,0c0-3.2,2.6-5.8,5.8-5.8H72c3.2,0,5.8,2.6,5.8,5.8l0,0 C77.8,190.9,75.2,193.4,71.9,193.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M65.3,62.9h252.1v46H59.1V69C59.1,65.6,61.9,62.9,65.3,62.9z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 65.1,
    y: 90.8,
    className: "st6",
    width: 246.2,
    height: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M444.5,150.2h-40.2c-2.5,0-4.5-2-4.5-4.5v-3.1c0-2.5,2-4.5,4.5-4.5h40.2c2.5,0,4.5,2,4.5,4.5v3.1 C449,148.2,447,150.2,444.5,150.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnePointFiveTon);
export default __webpack_public_path__ + "static/media/one_point_five_ton.a53e4dddf2c563cd2d0b4b70585e8ab1.svg";
export { ForwardRef as ReactComponent };